import dayjs from 'dayjs';
import operatorToText from './operatorToText';
import { DATE_FORMAT } from '../components/Forms/DatePicker';

const standardDatetimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;

function formatDate(input) {
  if (!input) return '';
  const parsed = dayjs(input);
  if (!parsed.isValid()) return input;
  return parsed.format(
    standardDatetimeRegex.test(input)
      ? DATE_FORMAT.LONG_DATE
      : DATE_FORMAT.MEDIUM_DATE,
  );
}

const dynamicDatePickerValueFormatter = value => {
  if (value?.operator === 'eqNull') {
    return 'None';
  }
  const parts = value?.value?.split(',');
  const data = parts.map(formatDate);
  if (data.length > 1) {
    return `${operatorToText(value?.operator)} ${data.join(' and ')}`;
  }
  return `${operatorToText(value?.operator)} ${data}`;
};

export default dynamicDatePickerValueFormatter;
